module.exports = __webpack_public_path__ + "static/media/logo-facebook.3437099e.svg";